/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export const SECURE_CONTACT_MODAL_ENROLL_UPDATE_FLOWS = Object.freeze({
  PRE_VERIFY: 'PRE_VERIFY',
  SELECT_TWO_FACTOR_PHONE: 'SELECT_TWO_FACTOR_PHONE',
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  CODE: 'CODE'
});

/**
 * Input props
 * @addEmail {boolean} - (Optional) used when adding a single EMAIL detail
 * @addFromTwoFactorPhone {boolean} - (Optional) used when adding a single PHONE detail, using a 2FA phone
 * @addPhone {boolean} - (Optional) used when adding a single PHONE detail
 * @close {function} - hook function that is called when the enroll modal closes
 * @detailToBeUpdated {object} - SecureContactDetail to be updated
 * @detailToBeVerified {object} - SecureContactDetail to be verified prior to enroll flow
 * @phoneNumber {string} - (Optional) used to enroll a SecureContactDetail using a 2FA phone
 * @phoneNumberDisplay {string} - (Optional) used when enrolling a SecureContactDetail using a 2FA phone, to display the phone number
 * @tPrefix {string} - ember i18n key prefix for all translation keys in secure contact enroll components
 * @uppercaseCountry {string} - (Optional) based on locale, used for ember-phone-number input default country selection
 *
 * Usage
 * {{#if this.enrollModalOpen}}
 *    <EmberMultipassComponents::SecureContact::Modals::Enroll::Base
 *       @addEmail={{eq this.methodToEnroll this.methodsToEnroll.EMAIL}}
 *       @addPhone={{eq this.methodToEnroll this.methodsToEnroll.PHONE}}
 *       @close={{this.handleEnrollModalClose}}
 *       @detailToBeUpdated={{this.detailToBeUpdated}}
 *       @detailToBeVerified={{this.detailToBeVerified}}
 *       @tPrefix={{@tPrefix}}
 *       @uppercaseCountry={{this.uppercaseCountry}}
 *    />
 *  {{/if}}
 */
let SecureContactModalEnrollComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactModalEnrollComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _defineProperty(this, "flows", SECURE_CONTACT_MODAL_ENROLL_UPDATE_FLOWS);
    _defineProperty(this, "methods", Object.freeze({
      PHONE: 'PHONE',
      EMAIL: 'EMAIL'
    }));
    _initializerDefineProperty(this, "method", _descriptor5, this);
    _initializerDefineProperty(this, "flow", _descriptor6, this);
    _initializerDefineProperty(this, "email", _descriptor7, this);
    _initializerDefineProperty(this, "emailDisplay", _descriptor8, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor9, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor10, this);
    _initializerDefineProperty(this, "smsBlockedManualOptInModalOpen", _descriptor11, this);
    _defineProperty(this, "handleModalInitialization", async element => {
      this.modalEl = element;
      this.setPhoneNumber(this.args.phoneNumber);
      this.setPhoneNumberDisplay(this.args.phoneNumberDisplay);
      await this.initialSecureContactEnrollFlow();
    });
  }
  get isUpdateFlow() {
    return !!this.args.detailToBeUpdated;
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get showCodeViewBackButton() {
    // Show back button if we are not enrolling using a two factor number, or if there are multiple
    // two factor numbers to choose from
    return !this.args.addFromTwoFactorPhone || this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails.length > 1;
  }
  async initialSecureContactEnrollFlow() {
    if (this.args.detailToBeVerified) {
      this.setFlow(this.flows.PRE_VERIFY);
      await this.sendPreVerifyCode();
    } else if (this.args.addFromTwoFactorPhone) {
      this.handleAddFromTwoFactorPhoneFlow();
    } else if (this.args.addPhone) {
      this.setFlow(this.flows.PHONE);
    } else {
      this.setFlow(this.flows.EMAIL);
    }
    if (this.args.addPhone) {
      this.setMethod(this.methods.PHONE);
    } else {
      this.setMethod(this.methods.EMAIL);
    }
  }
  handleAddFromTwoFactorPhoneFlow() {
    if (this.multipassfeClient.secureContactEligibleSmsTwoFactorDetails.length === 1) {
      this.setFlow(this.flows.CODE);
      this.sendCode();
    } else {
      this.setFlow(this.flows.SELECT_TWO_FACTOR_PHONE);
    }
  }
  handleMultipassError(error) {
    switch (error.message) {
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedManualOptInModalOpen = true;
        break;
      case 'SECURE_CONTACT_ALIAS_CONFLICT':
        this.marketToasts.critical(this.intl.t(`${this.tPrefix}secure_contact_modals.enroll.generic.errors.secure_contact_alias_conflict`));
        break;
      case 'TEMPORARY_LOCKOUT':
        this.marketToasts.critical(this.intl.t(`${this.tPrefix}secure_contact_modals.enroll.generic.errors.temporary_lockout`));
        break;
      default:
        this.logger.sentryError(error);
        this.marketToasts.critical(this.intl.t(`${this.tPrefix}secure_contact_modals.enroll.generic.errors.unknown`));
    }
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setMethod(newMethod) {
    this.method = newMethod;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  setEmail(newEmail) {
    this.email = newEmail;
    this.emailDisplay = newEmail;
  }
  async resendPreVerifyCodeDebounced() {
    debounce(this, this.sendPreVerifyCode, 500, true);
  }
  async sendPreVerifyCode() {
    try {
      if (this.args.detailToBeVerified?.phone) {
        await this.multipassfeClient.sendPhoneSecureContactCode(this.args.detailToBeVerified?.phone);
      } else if (this.args.detailToBeVerified?.email) {
        await this.multipassfeClient.sendEmailSecureContactCode(this.args.detailToBeVerified?.email);
      }
    } catch (e) {
      this.handleMultipassError(e);
    }
  }
  async sendCodeDebounced() {
    debounce(this, this.sendCode, 500, true);
  }
  async sendCode() {
    try {
      if (this.args.addPhone) {
        await this.multipassfeClient.sendPhoneSecureContactCode(this.phoneNumber);
      } else if (this.args.addEmail) {
        await this.multipassfeClient.sendEmailSecureContactCode(this.email);
      }
    } catch (e) {
      this.handleMultipassError(e);
    }
  }
  navigateToMethodFlow() {
    if (this.method === this.methods.PHONE) {
      if (this.args.addFromTwoFactorPhone) {
        this.handleAddFromTwoFactorPhoneFlow();
      } else {
        this.setFlow(this.flows.PHONE);
      }
    } else if (this.method === this.methods.EMAIL) {
      this.setFlow(this.flows.EMAIL);
    }
  }
  close() {
    this.args.close();
  }
  handleSmsBlockedManualOptInModalClose() {
    this.smsBlockedManualOptInModalOpen = false;
  }
  async finish() {
    await this.multipassfeClient.listSecureContact();
    this.close();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "method", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methods.PHONE;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.PHONE;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "email", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "emailDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "smsBlockedManualOptInModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendPreVerifyCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendPreVerifyCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendPreVerifyCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendPreVerifyCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToMethodFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToMethodFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "finish", [action], Object.getOwnPropertyDescriptor(_class.prototype, "finish"), _class.prototype), _class);
export { SecureContactModalEnrollComponent as default };